import { Injectable } from '@angular/core';
import { BaseOfficerService } from '../services/base-officer.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as OfficerDetailActions from './officer-details.store.actions';
import { switchMap, map, tap, exhaustMap, first } from 'rxjs';
import { LoggedInOfficer, LoggedInOfficerResponse, UserUIConfiguration } from '../models/logged-in-officer.models';
import { OfficerDetailFacade } from './officer-details-store.facade';
import { NotificationService } from '@shared/feature/notification-handling';
import { CacheService } from '@shared/utils/cache';
import { TranslationFromJsonService } from '@shared/feature/translate';

@Injectable()
export class OfficerDetailsEffects {
  getLoggedInOfficer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfficerDetailActions.getCurrentOfficer),
      switchMap(() =>
        this.service.getLoggedInOfficer().pipe(
          map((response: LoggedInOfficerResponse) => {
            return new LoggedInOfficer(
              response.UID,
              response.FirstName,
              response.LastName,
              false,
              response.Customer.UID,
              response.PictureFullPath,
              response.AutoClearFilters,
              response.Role,
              response.EmailAddress,
              response.Customer.UseMilitaryTime,
              response.CanDownloadFiles,
              response.TimeZone,
              response.ShareType,
              new UserUIConfiguration(response.UserUIConfiguration.IsNotificationBannerRead),
              response.HasCameraEvents
            );
          })
        )
      ),
      map((response) => OfficerDetailActions.getCurrentOfficerSuccess({ officer: response }))
    )
  );

  changeAutoClearFilters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfficerDetailActions.changeAutoClearFilters),
      switchMap((actions) => {
        return this.officerFacade.getLoggedInOfficer().pipe(
          first(),
          exhaustMap((officer) => {
            return this.service.changeLoggedInOfficerProfile(actions.newAutoClearFiltersValue, officer.uid).pipe(
              tap(() => this.notificationService.addSuccess(this.translationService.instant('profile-changed-successfully'))),
              map(() => {
                return OfficerDetailActions.changeAutoClearFiltersSuccess({ newAutoClearFiltersValue: actions.newAutoClearFiltersValue });
              })
            );
          })
        );
      })
    )
  );

  changeAutoClearFiltersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OfficerDetailActions.changeAutoClearFiltersSuccess),
        tap((x) => this.cacheService.autoClearFiltersUpdated(x.newAutoClearFiltersValue))
      ),
    { dispatch: false }
  );

  constructor(
    private service: BaseOfficerService,
    private actions$: Actions,
    private officerFacade: OfficerDetailFacade,
    private notificationService: NotificationService,
    private cacheService: CacheService,
    private translationService: TranslationFromJsonService
  ) {}
}
